import PropTypes from 'prop-types';
import SubtitleLink from './subtitleLink';
import './subtitle.scss';

const filterOutDuplicates = (geographical) => {
  const values = Object.values(geographical);

  // Use a Map to track unique names with a URL
  const uniqueByName = new Map();

  values.forEach((obj) => {
    if (obj?.name && !uniqueByName.has(obj?.name)) {
      if (obj?.url) uniqueByName.set(obj?.name, obj); // Add if has URL
    }
  });

  const result = Object.fromEntries(
    Object.entries(geographical).filter(
      ([, obj]) => uniqueByName.get(obj?.name) === obj,
    ),
  );

  return result
};

const Subtitle = ({ geographical, shouldShowRegion, className }) => {
  const filteredGeographical = filterOutDuplicates(geographical);
  const { resort = null, area, country, region } = filteredGeographical || {};

  return (
    <div className={className || 'gw-subtitle'}>
      <SubtitleLink geographicalNode={resort} useDivider />
      <SubtitleLink geographicalNode={area} useDivider={!resort} />
      {shouldShowRegion && !resort && (
        <SubtitleLink geographicalNode={region} useDivider />
      )}
      {(!resort || !area) && <SubtitleLink geographicalNode={country} />}
    </div>
  );
};

Subtitle.propTypes = {
  geographical: PropTypes.shape({
    resort: PropTypes.shape({}),
    country: PropTypes.shape({}),
    area: PropTypes.shape({}),
    region: PropTypes.shape({}),
  }).isRequired,
  shouldShowRegion: PropTypes.bool,
  className: PropTypes.string,
};

Subtitle.defaultProps = {
  shouldShowRegion: false,
  className: '',
};

export default Subtitle;
